import Button from "../../../components/elements/Button/Button";
import {useIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import axios from "axios";
import errorParser from "../../../components/ErrorParser/ErrorParser";
import LoadingComp from "../../../components/elements/LoadingComp/LoadingComp";
import ModalComp from "../../../components/ModalComp/ModalComp";
import SignaturePad from "react-signature-canvas";
import UploadImageComp from "../../../components/Upload/UploadImageComp";
import {base64File} from "../../../utils/functions";
import {useNavigate, useParams} from "react-router-dom";
import './ViewContract.scss';
import ModalMentions from "../../../components/ModalMentions/ModalMentions";
import moment from "moment";

export default function ViewContract() {

    const intl = useIntl();
    const jwt = localStorage.getItem('jwt')
    let params = useParams();
    const navigate = useNavigate()

    const [pdf, setPdf] = useState([])

    const [loading, setLoading] = useState(true)
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [modalMentionsIsOpen, setModalMentionsIsOpen] = useState(false)
    const [loadingAddMentions, setLoadingAddMentions] = useState(false)

    const [useImage, setUseImage] = useState(false)
    const [newImage, setNewImage] = useState(null)
    const [imageUrl, setImageUrl] = useState('')
    const [sigPad, setSigPad] = useState({})
    const [update, setUpdate] = useState(0)
    const [mentionsHistory, setMentionsHistory] = useState([])
    const [mentions, setMentions] = useState('')
    const [contract, setContract] = useState([])
    const [loadingSign, setLoadingSign] = useState(false)

    useEffect(() => {
        getContract()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getPdf = async (company, client) => {
        axios.get(process.env.REACT_APP_API + '/contracts/download/' + params.id + '/' + client.id + '/' + company, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/pdf',
            }
        }).then((response) => {
            // Create blob link to download

            const url = window.URL.createObjectURL(
                response.data,
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                'contract-' + params.id + '.pdf',
            );
            setPdf(url)
            setLoading(false)
        })
            .catch(err => {
                errorParser(err, intl)
            })
    }
    const getContract = async () => {
        axios.get(process.env.REACT_APP_API + '/contracts/' + params.id, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                setContract(response.data)
                setMentionsHistory(response.data.notes ?? [])
                if (response.data.is_pdf) {
                    fetch(process.env.REACT_APP_API + response.data.pdf.url).then((response) => {
                        response.blob().then((blob) => {

                            // Creating new object of PDF file
                            const fileURL =
                                window.URL.createObjectURL(blob);

                            // Setting various property values
                            let alink = document.createElement("a");
                            alink.href = fileURL;
                            setPdf(fileURL)
                            setLoading(false)
                        });
                    });
                } else
                    getPdf(response.data.company.id, response.data.client)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }
    const addSignature = async (e) => {
        e.preventDefault();

        if (newImage || sigPad) {
            setLoadingSign(true)
            /* let signature = '';*/
            if (useImage) {
                const promise = base64File(imageUrl)

                promise.then((value) => {
                    add(value)
                });
            } else {
                add(sigPad.getTrimmedCanvas().toDataURL('image/png'))
                setSigPad({})
            }

        }
    }
    const addMentions = async (e) => {
        e.preventDefault();
        setLoadingAddMentions(true)
        let ment = mentionsHistory;
        ment.push({
            user: 'client',
            note: mentions,
            date: moment(),
            user_id: contract.client.id
        })
        let payload = {
            notes: ment
        }
        axios.post(process.env.REACT_APP_API + '/contracts/add-mentions/' + params.id, payload, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        }).then((response) => {
            setMentions('')
            getContract()
            setLoadingAddMentions(false)
        })
            .catch(err => {
                errorParser(err, intl)
                setLoadingAddMentions(false)
            })
    }

    const add = (signature) => {
        let formData = new FormData()
        formData.append('signature', signature)

        axios.post(process.env.REACT_APP_API + '/contracts/sign/' + params.id, formData, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        }).then((response) => {
            setLoadingSign(false)
            setModalIsOpen(false)
            navigate(-1)
        })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    if (loading) {
        return <LoadingComp/>
    }

    return (
        <div className="container view-contract">

            <h1 className={"container-title"}>{intl.formatMessage({id: 'contracts.title'})}</h1>

            <div className="card">

                <div className={"header"}>
                    <div className={"row"}>
                        {contract.is_pdf !== true && <div className={"col-md-6 col-sm-12"}>
                            <Button
                                className={"btn-primary w-100"}
                                value={intl.formatMessage({id: 'contracts.client.sign'})}
                                onClick={() => {
                                    setModalIsOpen(true)
                                }}
                            />
                        </div>}
                        <div className={contract.is_pdf ? "col-12" : "col-md-6 col-sm-12"}>
                            <Button
                                className={"btn-primary w-100"}
                                value={intl.formatMessage({id: 'contracts.client.add_mentions'})}
                                onClick={() => {
                                    setModalMentionsIsOpen(true)
                                }}
                            />
                        </div>
                    </div>
                </div>
                <iframe src={pdf} title={'Contract'}>

                </iframe>


                {/*  */}
            </div>


            <ModalComp
                title={intl.formatMessage({id: 'settings.company.sign_here'})}
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                className={"sign-contract"}
            >
                <form onSubmit={(e) => addSignature(e)}>
                    <div className={"content"}>
                        <div className={"tab-switch with-content"}>
                            <div className={"tab " + (!useImage ? "active" : "")} onClick={() => setUseImage(false)}>
                                {intl.formatMessage({id: 'settings.company.sign_here'})}
                            </div>
                            <div className={"tab " + (useImage ? "active" : "")} onClick={() => setUseImage(true)}>
                                {intl.formatMessage({id: 'settings.locations.upload_image'})}
                            </div>
                        </div>
                        <div className={"tab-content p-2"}>
                            {
                                useImage ?
                                    <UploadImageComp
                                        image={newImage}
                                        setImage={setNewImage}
                                        imageUrl={imageUrl}
                                        setImageUrl={setImageUrl}
                                        className={"p-3"}
                                    />
                                    :
                                    <div>
                                        <div className={"signature-container"}
                                             onMouseUp={() => {
                                                 setUpdate(update + 1)
                                             }
                                             }
                                        >
                                            <SignaturePad ref={(ref) => {
                                                setSigPad(ref)
                                            }} canvasProps={{className: 'sigCanvas'}}/>
                                            <div key={update} className={((sigPad && Object.keys(sigPad).length === 0)
                                            || (sigPad && sigPad.isEmpty()) ? 'signature-overlay' : 'd-none')}>
                                                <i className="fa-solid fa-pencil icon"></i>
                                                <div
                                                    className={"title"}>{intl.formatMessage({id: "general.add.signature.title"})}</div>
                                            </div>
                                        </div>


                                        <Button key={update}
                                                className={"btn-gray mt-2 ms-auto " + ((sigPad && Object.keys(sigPad).length === 0)
                                                || (sigPad && sigPad.isEmpty()) ? 'disabled' : '')}
                                                style={{width: '100%'}}
                                                icon={"fa-solid fa-trash"}
                                                value={intl.formatMessage({id: 'general.buttons.delete'})}
                                                type={'button'}
                                                disabled={(sigPad && Object.keys(sigPad).length === 0)
                                                    || (sigPad && sigPad.isEmpty())}
                                                onClick={() => sigPad.clear()}
                                        />
                                    </div>
                            }
                        </div>
                    </div>
                    <div className={"footer"}>

                        <div className={"row"}>
                            <div className={"col-12 d-flex"}>
                                <Button
                                    loading={loadingSign}
                                    disabled={loadingSign}
                                    className={"btn-primary mt-4 ms-auto"}
                                    value={intl.formatMessage({id: 'contracts.client.sign'})}
                                    type={'submit'}
                                />
                            </div>
                        </div>

                    </div>
                </form>

            </ModalComp>
            <ModalMentions
                modalMentionsIsOpen={modalMentionsIsOpen}
                setModalMentionsIsOpen={setModalMentionsIsOpen}
                mentionsHistory={mentionsHistory}
                mentions={mentions}
                setMentions={setMentions}
                addMentions={addMentions}
                user={'client'}
                contract={contract}
                loadingAddMentions={loadingAddMentions}
            />
        </div>

    );
}

